<template>
    <div :class="infoAnimation">
        <span v-show="cardActivation == 1 || cardActivation == 4">
            {{ $t(cardInfoHead) }}
            <br><br>
        </span>
        <p style="white-space: pre-line;">
            <span v-show="cardActivation == 2 || cardActivation == 3">{{ $t(cardInfoHead) }}</span>
            {{ $t(cardInfo) }}
        </p>
    </div>
</template>

<script>
export default {
  props: {
    infoAnimation: {
        type: String
    },
    cardInfoHead: {
      type: String
    },
    cardInfo: {
      type: String
    },
    cardActivation: {
      type: Number
    }
  }
}
</script>